import React from 'react';
import { gallery } from '../data/gallery';
export function Gallery() {
  return <section id="gallery" className="border-t border-neutral-200 bg-neutral-50" data-id="element-42" data-mp="34cqa1722l1t3">
      <div className="mx-auto max-w-6xl px-6 py-20 lg:py-28" data-id="element-43" data-mp="34eswjh40kct2">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-44" data-mp="3iawm2x3xzwz7">
          <div className="max-w-xl" data-id="element-45" data-mp="3dcv82qldinul">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-500" data-id="element-46" data-mp="3ddxv2nfks658">
              The work
            </p>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-47" data-mp="2koh47u7lsxb4">
              Homes, farms, and everything between.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-neutral-600" data-id="element-48" data-mp="2zfgdl7g9jpvr">
            A few recent jobs across Salem, Keizer, and the surrounding valley.
          </p>
        </div>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-49" data-mp="26v81udi2pc23">
          {gallery.map((item, index) => <li key={item.src} className={index === 0 ? 'sm:col-span-2' : undefined} data-id="element-50" data-mp="21vvd1n7n5uwv" data-mpi={index}>
              <figure className="group h-full" data-id="element-51" data-mp="rcb0loqy1t76">
                <div className="relative overflow-hidden bg-neutral-200" data-id="element-52" data-mp="wb4az8axp434">
                  <img src={item.src} alt={item.alt} loading="lazy" className={`w-full object-cover transition-transform duration-500 group-hover:scale-[1.03] ${index === 0 ? 'aspect-[16/10]' : 'aspect-[4/3]'}`} data-id="element-53" data-mp="112cn4c3nf3jz" />
                </div>
                <figcaption className="mt-3 flex items-baseline justify-between gap-4" data-id="element-54" data-mp="dew4k166qn68">
                  <span className="text-sm text-neutral-700" data-id="element-55" data-mp="hd27sz7tekme">{item.caption}</span>
                  <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.16em] text-neutral-400" data-id="element-56" data-mp="me9esw24vfs0">
                    {item.tag}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}